import React from 'react'
import Switcher from '@/components/Switcher'
import type { SDUIComponentProps } from '@/types/sduiTypes'

/**
 * SDUI Switch adapter — wraps the existing Switcher component
 * to conform to the SDUI component contract.
 */
const SDUISwitch: React.FC<SDUIComponentProps> = ({
    id,
    label,
    value,
    errors,
    disabled,
    isLoading,
    checkedContent,
    unCheckedContent,
    onChange,
}) => {
    const hasErrors = errors && errors.length > 0

    const handleChange = (checked: boolean) => {
        onChange?.(checked)
    }

    return (
        <div className="w-full flex items-center gap-3">
            {label && (
                <label
                    htmlFor={id}
                    className="font-medium text-gray-700 dark:text-gray-200 text-sm"
                >
                    {label}
                </label>
            )}
            <Switcher
                checked={Boolean(value)}
                disabled={disabled}
                isLoading={isLoading}
                checkedContent={(checkedContent as string) || undefined}
                unCheckedContent={(unCheckedContent as string) || undefined}
                onChange={handleChange}
            />
            {hasErrors && (
                <div className="ml-2">
                    {errors.map((err, idx) => (
                        <p
                            key={`${id}-error-${idx}`}
                            className="text-red-500 text-xs"
                        >
                            {err}
                        </p>
                    ))}
                </div>
            )}
        </div>
    )
}

SDUISwitch.displayName = 'SDUISwitch'

export default SDUISwitch
